import { Switch, BrowserRouter as Router } from "react-router-dom"
import Route from "components/route"
import Login from "pages/login"
import Clients from "pages/clients"
import Dashboard from "pages/dashboard"
import Board from "pages/board"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import Calendar from "pages/calendar"
import List from "pages/list"
import Test from "pages/test"
import ForgotPassword from "pages/forgot-password"
import PasswordSetup from "pages/password-setup"
import { MainDomain } from 'api';

function App() {

  document.title = `WF ${MainDomain}`


  return (
    <Router>
      <Switch>
        <Route path="/" exact showHeader={false} validateToken={false}>
          <Login />
        </Route>
        <Route path="/login" showHeader={false} validateToken={false}>
          <Login />
        </Route>
        <Route path="/clients">
          <Clients />
        </Route>
        <Route path="/client/:clientId/dashboard">
          <Dashboard isArchivedItems={false}/>
        </Route>
        <Route path="/client/:clientId/dashboard/archived">
          <Dashboard isArchivedItems={true}/>
        </Route>
        <Route path="/client/:clientId/board/:boardId" exact>
          <Board />
        </Route>
        <Route path="/client/:clientId/board/:boardId/ticket/:ticketId" exact>
          <Board />
        </Route>
        <Route path="/client/:clientId/list/:boardId" exact>
          <List />
        </Route>
        <Route path="/client/:clientId/calendar" exact>
          <Calendar />
        </Route>
        <Route path="/client/:clientId/calendar/ticket/:ticketId" exact>
          <Calendar />
        </Route>
        <Route path="/client/:clientId/calendar/item/:itemId" exact>
          <Calendar />
        </Route>
        <Route showHeader={false} validateToken={false} path="/forgot-password">
          <ForgotPassword />
        </Route>
        <Route showHeader={false} validateToken={false} path="/password-setup/:contactId">
          <PasswordSetup />
        </Route>
        <Route path="/test">
          <Test />
        </Route>
      </Switch>
      <ToastContainer hideProgressBar={true} newestOnTop={true} />
    </Router>
  )
}

export default App
